import {useSelector} from "react-redux";
import {getAssets} from "../../../ducks/assets-duck.js";
import {getSubPathCache} from "../../../ducks/user-duck.js";
import {APP_ROUTES} from "../../../App.jsx";
import {scrollToTop, useNavigation} from "../../util/navigation/navigation.js";
import {ASSET_IDS} from "../../../util/asset-ids.js";
import DonutChart from "../../util/donut/DonutChart.jsx";

export default () => {

    const assets = useSelector(getAssets)
    const subPathCache = useSelector(getSubPathCache)

    const {navigateTo} = useNavigation(scrollToTop)

    const itemsReturn = assets.filter(asset => asset.id !== ASSET_IDS.DAI).map(({id, name, code, value}) => ({
        id,
        label: name,
        pieLabel: code,
        value: value,
    }))

    const itemsGain = assets.filter(asset => asset.id !== ASSET_IDS.DAI).map(({id, name, code, gain}) => ({
        id,
        label: name,
        pieLabel: code,
        value: gain,
    }))

    const objectOnClick = id => {
        const route = subPathCache ? APP_ROUTES.history.replace('history', subPathCache) : APP_ROUTES.history
        navigateTo(route, {filterId: id})
    }

    return (
        <div className='distribution flex-vertical-center'>
            <div>
                <h2>
                    Value distribution
                </h2>
                <DonutChart
                    data={itemsReturn}
                    size={180}
                    thickness={12}
                    objectOnClick={objectOnClick}
                />
            </div>
            <div>
                <h2>
                    Return distribution
                </h2>
                <DonutChart
                    data={itemsGain}
                    size={180}
                    thickness={12}
                    objectOnClick={objectOnClick}
                />
            </div>
        </div>
    )
}